import { useState, useEffect } from 'react'
import { trainingApi } from '../api'
import type { TrainingProjection, TrainingSet, RelatedUser, TrainingSetStats } from '../types/api'

/**
 * Custom hook to fetch and manage training set data
 */
export function useTrainingSetData(setId: string | undefined) {
  const [trainings, setTrainings] = useState<TrainingProjection[]>([])
  const [loading, setLoading] = useState(true)
  const [trainingSet, setTrainingSet] = useState<TrainingSet | null>(null)
  const [relatedUser, setRelatedUser] = useState<RelatedUser | null>(null)
  const [stats, setStats] = useState<TrainingSetStats | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchTrainings = async () => {
      if (!setId) return

      setLoading(true)
      setError(null)

      try {
        const data = await trainingApi.getTrainingSetDetails(parseInt(setId))
        setTrainings(data.trainProjections)
        setTrainingSet(data.trainingSet)
        setRelatedUser(data.relatedUser)
        setStats(data.stats)
      } catch (err) {
        console.error('Error fetching trainings:', err)
        setError(err instanceof Error ? err.message : 'Failed to load trainings')
      } finally {
        setLoading(false)
      }
    }

    fetchTrainings()
  }, [setId])

  const refetch = async () => {
    if (!setId) return

    try {
      const data = await trainingApi.getTrainingSetDetails(parseInt(setId))
      setTrainings(data.trainProjections)
      setTrainingSet(data.trainingSet)
      setRelatedUser(data.relatedUser)
      setStats(data.stats)
    } catch (err) {
      console.error('Error refetching trainings:', err)
    }
  }

  return {
    trainings,
    loading,
    trainingSet,
    relatedUser,
    stats,
    error,
    refetch
  }
}
